/**
 * ELEMENT 按需引入
 * @author Sky
 */
import Vue from 'vue'
// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css'
// collapse 展开折叠
import {
  Progress,
  Tabs,
  Loading,
  TabPane,
  Row,
  Col
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.prototype.$ELEMENT = { size: 'small' }

Vue.use(Progress)
Vue.use(Tabs)
Vue.use(Loading)
Vue.use(TabPane)
Vue.use(Row)
Vue.use(Col)
